import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";

@Component({
    selector: 'na-remindSwitch',
    templateUrl: './remind-switch.component.html',
    styleUrls: ['../uiElement.style.css'],
    styles: [
        `.hint {
    background: var(--yellow-3);
    color: var(--white);
    padding: 0.5rem 1rem;
    width: 25vw;
    border-radius: 0.4rem;
    border: none;
}
        i:hover {
            cursor: pointer;
        }
`
    ],
    standalone: false
})
export class RemindSwitchComponent implements OnInit {
    static RemindSwitchIndex: number = 1;

    get id(): string {
        return 'remind-switch-' + RemindSwitchComponent.RemindSwitchIndex;
    }

    @Input('title') _title: string = '';
    @Input('supportHint') _supportHint: boolean = false;
    @Input('hintMsg') _hintMsg: string = '';
    @Input('supportPopup') _supportPopup: boolean = false;
    @Input('popupMsg') _popupMsg: string = '';
    @Input('disabled') _disabled: boolean = false;

    @Output() onSwitchChanged = new EventEmitter<boolean>();
    @Output() onPopupEnabled = new EventEmitter<boolean>();

    @ViewChild('btnPopup') private _btnPopupRef: ElementRef;

    _bSwitchOn: boolean = false;
    _disablePopupInFuture: boolean = false;

    constructor() {
        RemindSwitchComponent.RemindSwitchIndex++;
    }

    ngOnInit(): void {
        // load cache from localStorage
    }

    turnOnOff(checked: boolean): void {
        if (this._bSwitchOn != checked) {
            this._bSwitchOn = checked;
            if (this._bSwitchOn) {
                if (this._supportPopup) {
                    this._btnPopupRef.nativeElement.click();
                    return;
                }
            }

            this.onSwitchChanged.emit(this._bSwitchOn);
        }
    }

    disablePopupInFuture(checked: boolean): void {
        this.onPopupEnabled.emit(!checked);
    }

    consentPopupMsg(): void {
        this.onSwitchChanged.emit(this._bSwitchOn);
    }
}